module.exports = __webpack_public_path__ + "5a1df149ed3ba137b0748a7d5c0165ef.svg";